import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IRollbackProductsFromManufacturingPayload {
    designID: number;
    includeD365Cleanup: boolean;
    mItemID: number;
}

async function rollbackProductsFromManufacturing(
    payload: IRollbackProductsFromManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/RollbackProductsFromManufacturing",
        payload,
    );
    return response.data;
}

export function useRollbackProductsFromManufacturing() {
    return useMutation({
        mutationFn: rollbackProductsFromManufacturing,
    });
}
